import script from "./CompleteActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteActionButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__